<template>
  <section class="spring">
    <div class="spring__content">
      <h1 class="spring__title">Save Up to $250 on INE Training and Certifications</h1>
      <div class="spring__intro-wrapper">
        <div class="spring__description">
          <p>
            Choose to save on INE Premium, Fundamentals Annual, Certification + Training Bundles, or
            INE Security Certifications to Spring into Success!
          </p>
        </div>
        <div class="spring__links-wrapper">
          <a
            class="btn btn--primary btn--full-mobile"
            href="https://learn.ine.com/promo-spring-into-success"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shop Savings
          </a>
          <a
            class="btn btn--secondary btn--full-mobile"
            :href="enterprisePromoUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Save on Training for Teams
          </a>
        </div>
      </div>
    </div>
    <div class="spring__icon">
      <div class="spring__icon-logo-wrapper">
        <img :src="SpringLogoImg" alt="Spring Savings Promo" class="spring__icon-logo" />
      </div>
    </div>
  </section>
</template>

<script>
import { routesRules } from '@/helpers/mixins'
import SpringLogoPng from '@/assets/images/hero-section/spring/spring-logo.png'
import CONSTANTS from '@/constants'

const {
  LINKS: { SPRING_SAVINGS_2025, SPRING_SAVINGS_2025_PROMO_PAGE },
} = CONSTANTS

export default {
  name: 'SpringHeroSection',
  mixins: [routesRules],
  data() {
    return {
      SpringLogoImg: SpringLogoPng,
      enterprisePromoUrl: SPRING_SAVINGS_2025,
      promosUrl: SPRING_SAVINGS_2025_PROMO_PAGE,
    }
  },
  methods: {
    scrollToSubscriptions() {
      const elementContent = document.querySelector(`.shop__content-subscriptions`)
      const elementPosition = elementContent.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - 60
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.spring {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  @include font-book;
  display: flex;
  flex-flow: column-reverse;
  align-items: center;
  position: relative;
  padding: 0 20px 20px 20px;
  @include mobile {
    flex-flow: row;
    gap: 20px;
  }
  @include tablet {
    gap: 0;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 50px 0 100px 0;
    gap: 0;
  }
  &__title {
    @include font-medium;
    color: var(--white);
    font-size: rem(35px);
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    margin: 0;
    @include mobile {
      @include font-medium;
      font-size: rem(37px);
      font-weight: 900;
      line-height: normal;
    }
    @include desktop {
      @include font-book;
      font-size: rem(44px);
      font-weight: 700;
      line-height: normal;
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__description {
    p {
      margin: 0 0 10px 0;
    }
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    width: 100%;

    &-highlight {
      color: var(--white);
      font-weight: 700;
    }
    &-couponflash {
      color: #88ebfe;
      font-weight: 700;
    }
    &-couponbundle {
      color: #fb99b3;
      font-weight: 700;
    }

    @include mobile {
      width: 100%;
    }
    @include desktop {
      width: 85%;
      font-size: rem(24px);
      line-height: 32px;
    }
  }
  &__links-wrapper {
    display: flex;
    gap: 10px;
    flex-direction: column;
    margin-top: 30px;
    > * {
      @include mobile {
        height: 36px;
        font-size: 14px;
      }
      @include tablet {
        height: 36px;
        font-size: 16px;
      }
      @include desktop {
        height: 47px;
      }
    }

    @include tablet {
      flex-direction: row;
    }
  }

  &__content {
    display: flex;
    flex-flow: column;
    gap: 20px;
    margin-top: 20px;

    @include mobile {
      margin-top: 0;
    }
  }
  &__icon {
    position: relative;

    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &-logo {
      width: 100%;
    }
    &-logo-wrapper {
      margin: 0;
      display: flex;
      justify-content: center;
      @include mobile {
        width: 366px;
      }
      @include tablet {
        width: 356px;
      }
      @include desktop {
        width: 554px;
      }
    }
  }
}
</style>
